import {
  CHECKOUT_PAGE_ROOT_CONTEXT_ID,
  CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID,
  ORDER_BINDING_CONTEXT_ID,
} from './identifiers';

import type {
  BindingContextDef,
  BindingContextTypeDef,
  TypeReferenceBuilder,
  BindingContextRelationshipDef,
} from '@packages/systems/dynamo/source-types';

export const checkoutPageRootContextType: BindingContextTypeDef = {
  entity: 'PageRoot',
  id: CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID,
  label: 'Checkout Page Root',
  iconName: 'product',
};

export function checkoutPageRootContext<RootTRef, EntityTRef, ListTRef>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindingContextDef<RootTRef, EntityTRef, ListTRef> {
  return {
    variant: 'Page',
    id: CHECKOUT_PAGE_ROOT_CONTEXT_ID,
    label: 'Checkout',
    type: typeReferenceBuilder.entityOf({
      entity: 'PageRoot',
      id: CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID,
    }),
    matchPage: (page) => page.utilKey === 'ecommerce-checkout',
  };
}

export function checkoutPageRelationships<RootTRef, EntityTRef, ListTRef>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindingContextRelationshipDef<RootTRef, EntityTRef> {
  return {
    type: typeReferenceBuilder.entityOf({
      entity: 'PageRoot',
      id: CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID,
    }),
    relativeContexts: [ORDER_BINDING_CONTEXT_ID],
  };
}
